// Fork JavaMifi: pilihan "Cause or Reason" tiket, salinan field tickets.cause_or_reason di NocoBase (21 Okt 2026).
// Value harus sama persis dengan NocoBase karena disinkron ke tabel tickets.
export const CAUSE_REASONS = [
  { value: 'bad_signal', label: 'Bad Signal' },
  { value: 'battery_issue', label: 'Battery Issue' },
  { value: 'belum_assign', label: 'Belum Assign' },
  { value: 'bootloop_or_software_issue', label: 'Bootloop or Software Issue' },
  { value: 'code_110', label: 'Code 110' },
  { value: 'code_12', label: 'Code 12' },
  { value: 'code_6', label: 'Code 6' },
  { value: 'code_7', label: 'Code 7' },
  { value: 'device_broken', label: 'Device Broken' },
  { value: 'device_cannot_turn_on', label: "Device Can't Turn On" },
  { value: 'effective_time_issue', label: 'Effective Time Issue' },
  { value: 'fup_product_plan', label: 'FUP (Product Plan)' },
  { value: 'incorrect_password', label: 'Incorrect Password' },
  { value: 'indosat_bad_signal', label: 'Indosat Bad Signal' },
  { value: 'modem_berbeda', label: 'Modem Berbeda' },
  {
    value: 'modem_tertinggal_atau_hilang',
    label: 'Modem Tertinggal atau Hilang',
  },
  { value: 'manual_operator', label: 'Manual Operator' },
  { value: 'need_restart', label: 'Need Restart' },
  { value: 'not_charged_device', label: 'Not Charged Device' },
  { value: 'request_aktivasi', label: 'Request Aktivasi' },
  { value: 'request_cancel', label: 'Request Cancel' },
  { value: 'registration_issue', label: 'Registration Issue' },
  { value: 'salah_sticker_device', label: 'Salah Sticker Device' },
  { value: 'set_ulang_apn', label: 'Set Ulang APN' },
  { value: 'slow_connection', label: 'Slow Connection' },
  { value: 'slow_connection_over_2gb', label: 'Slow Connection >2GB' },
  { value: 'slow_connection_over_3gb', label: 'Slow Connection >3GB' },
  { value: 'stuck_registering', label: 'Stuck Registering' },
  { value: 'stuck_searching', label: 'Stuck Searching' },
  { value: 'sudah_expired_atau_habis', label: 'Sudah Expired atau Habis' },
  { value: 'telkomsel_bad_signal', label: 'Telkomsel Bad Signal' },
  { value: 'uncovered', label: 'Uncovered' },
  { value: 'unsupported_device', label: 'Unsupported Device' },
  { value: 'vsim_issue', label: 'Vsim Issue' },
  { value: 'xl_bad_signal', label: 'XL Bad Signal' },
  { value: 'switch_usercode_or_paket', label: 'Switch Usercode/Paket' },
  { value: 'tidak_bisa_scan', label: 'Tidak Bisa Scan' },
  { value: 'scanned', label: 'Scanned' },
  { value: 'ssid_not_detected', label: 'SSID Not Detected' },
  { value: 'tidak_support_tiktok', label: 'Tidak Support Tiktok' },
  { value: 'sim_failure', label: 'SIM Failure' },
];

// Data NocoBase: cause_or_reason praktis hanya diisi tiket Technical (6.402/6.449, 60 hari) -> wajib untuk tim teknikal saja.
export const CAUSE_REQUIRED_TEAM = 'teknikal';
